import { useSnackbar } from "notistack";

import { useCallback } from "react";

import usePlatform from "@/hooks/usePlatform";

import { ConditionType } from "./useCondition";

const useCheckCondition = () => {
  const { enqueueSnackbar } = useSnackbar();
  const { isMobile } = usePlatform();

  const checkCondition = useCallback(
    (data: ConditionType) => {
      let errMsg = "";
      const { fromLocation, toLocation } = data;

      if (!fromLocation.length && !toLocation.length) {
        return errMsg;
      }
      if (!fromLocation.length) {
        errMsg = "Please select departure location";
      } else if (!toLocation.length) {
        errMsg = "Please select arrival location";
      } else if (!data.startDate) {
        errMsg = "Please select start date";
      } else if (!data.endDate) {
        errMsg = "Please select end date";
      }

      if (errMsg) {
        enqueueSnackbar(`${errMsg}!`, {
          variant: "info",
          anchorOrigin: {
            vertical: isMobile ? "bottom" : "top",
            horizontal: isMobile ? "center" : "right",
          },
          autoHideDuration: 2000,
        });
      }

      return errMsg;
    },
    [isMobile, enqueueSnackbar]
  );

  return { checkCondition };
};

export default useCheckCondition;
